import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('contractTerminationCurrentMonth/table', 'لیست پرسنل');
tbl.add(new Xtc('personnel.id', 'کد پرسنلی').hidden().filterText());
tbl.add(new Xtc('personnel.name', 'نام و نام خانوادگی').filterText())
tbl.add(new Xtc('start_atj', 'تاریخ شروع قرارداد').filterDate().filterKey('start_at'))
tbl.add(new Xtc('end_atj', 'تاریخ اتمام قرارداد').filterDate().filterKey('end_at'))
tbl.add(new Xtc('reason_termination', 'علت فسخ قرارداد').filterText())
export default tbl;
